import { useEffect } from "react";
import confetti from "canvas-confetti";

export default function Hooray() {
  useEffect(() => {
    const burst = () => {
      confetti({
        particleCount: 50 + Math.random() * 100,
        spread: 50 + Math.random() * 80,
        startVelocity: 30 + Math.random() * 20,
        origin: {
          x: Math.random(),
          y: 0.6 + (Math.random() * 0.1 - 0.05),
        },
      });
    };

    // 🌈 initial pop
    burst();

    // 🌊 rhythmic bursts
    const interval = setInterval(burst, 1200);

    // 💥 final explosion
    const finalExplosion = setTimeout(() => {
      clearInterval(interval);

      confetti({
        particleCount: 300,
        spread: 180,
        startVelocity: 45,
        scalar: 1.2,
        origin: { x: 0.5, y: 0.5 },
      });

      // secondary shockwave burst
      setTimeout(() => {
        confetti({
          particleCount: 150,
          spread: 120,
          startVelocity: 35,
          origin: { x: 0.2, y: 0.6 },
        });

        confetti({
          particleCount: 150,
          spread: 120,
          startVelocity: 35,
          origin: { x: 0.8, y: 0.6 },
        });
      }, 300);
    }, 6000);

    return () => {
      clearInterval(interval);
      clearTimeout(finalExplosion);
    };
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "20vh" }}>
      <h1>🎉 YAYYYYY 🎉</h1>
      <p>HOOOROAAAAAY</p>
      <p>we should kiss ;)</p>
    </div>
  );
}